import { Typography } from "@mui/material";


const ValidationError = ({ formErrors }: ValidationErrorProps) => {
  return (
    <>
      {formErrors ? (
        <Typography style={styles.validationError}>{formErrors}</Typography>
      ) : null}
    </>
  );
};
export default ValidationError;

const styles = {
  validationError: {
    marginTop: 1,
    color: 'red',
    width: "100%",
    fontSize: "12px",
    fontWeight: 400,
  },
};

type ValidationErrorProps = {
  formErrors: string;

};
